const initialState = {
    activeId: null,
    flyoutProps: {}
}

const modal = (state = initialState, action) => {
    switch (action.type) {
        case 'FLYOUT_CLOSE_REQUESTED':
            return {
                ...initialState
            };

        case 'FLYOUT_OPEN_REQUESTED':
            return Object.assign({}, state, {
                activeId: action.payload.flyoutId,
                flyoutProps: action.payload.flyoutProps
            });

    default:
        return state
    }    
}

export default modal;
